import { useAppSelector } from "../../app/hooks";
import { getUserData } from "../../features/user/userSlice" ;

export const useUserData = ()=>{
    const USER = useAppSelector( getUserData );
    return USER ;
}